import React from 'react';

const instructionalPart1Description = (
  <div>
    <div>
      Both you and your past employer fill out sections of VA Form 21-4192.
      You’ll complete your part first, then send the form to your past employer
      to finish and sign.
    </div>
    <img src="/img/part1-image.png" alt="VA Form 21-4192" />
    <span>VA Form 21-4192</span>
    <p>
      <strong>Note:</strong> You don’t need to turn in a VA Form 21-4192 for any
      employers who have gone out of business or any time you were
      self-employed.
    </p>
  </div>
);

export default instructionalPart1Description;
